import template from './accountTransfer.html';

export const accountTransferComponent = {
  name: 'accountTransfer',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  bindings: {
    oldBank: '<',
    newBank: '<',
  },
};



// WEBPACK FOOTER //
// ./src/app/components/overview/components/accountTransfer/accountTransfer.component.js